import React, { useCallback, useState } from 'react';

import { WpGifPickerDropdown } from 'Wpds/components/gif';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

import { useTooltip, WpTooltipOverlay } from 'Wpds/components/tooltip';

import './SidePanelTextEditorGifPicker.scss';

type Props = {
  onGifAdd: Function;
};

function SidePanelTextEditorGifPicker({ onGifAdd }: Props) {
  const tooltip = useTooltip({ placement: 'top' });
  const [isOpen, setIsOpen] = useState(false);

  const handleGifClick = useCallback(
    gif => {
      setIsOpen(false);
      onGifAdd(gif.images);
    },
    [onGifAdd]
  );

  return (
    <>
      <WpGifPickerDropdown open={isOpen} placement="top" onSelect={handleGifClick}>
        <WpButton variant="tertiary" size="sm" ref={tooltip.targetRef}>
          <WpIcon name="gif" prefix="fac" />
        </WpButton>
      </WpGifPickerDropdown>
      <WpTooltipOverlay context={tooltip}>Add Gif</WpTooltipOverlay>
    </>
  );
}

export default SidePanelTextEditorGifPicker;
